'use strict';
var ActionTypes = require('../constants/ActionTypes');
var storeHelper = require('../helper/storeHelper')

function app(state, action) {
  var payload = action.payload;
  switch (action.type) {
  case ActionTypes.PROJECT_LOAD_DONE:
    return payload;
  default:
    return state || null;
  }
}

function current(state, action) {
  var payload = action.payload;
  switch (action.type) {
  case ActionTypes.PAGE_LOAD_DONE:
    return payload;
  case ActionTypes.FINISH_OPEN_PAGE:
    return payload;
  default:
    return state || null;
  }
}

function animation(state, action) {
  var payload = action.payload;
  switch (action.type) {
  case ActionTypes.PAGE_REDIRECT_DONE:
    return payload.animation;
  case ActionTypes.PAGE_LOAD_DONE: // 如果是要求打开页面了, 那么动画应该置为空了
    return null;
  case ActionTypes.FINISH_OPEN_PAGE:
    return null;
  default:
    return state;
  }
}

function target(state, action) {
  var payload = action.payload;
  switch (action.type) {
  case ActionTypes.PAGE_REDIRECT_DONE:
    return payload.page;
  case ActionTypes.PAGE_LOAD_DONE: // 如果是要求打开页面了, 那么目标页面就应该置为空了
    return null;
  case ActionTypes.FINISH_OPEN_PAGE:
    return null;
  default:
    return state;
  }
}

function config(state, action) {
  return state;
}

function review(state, action) {
  var payload = action.payload;
  switch (action.type) {
  case ActionTypes.LOAD_REVIEW_DATA_REQUEST:
    storeHelper.set('loadState', 'wait');
    return [];
  case ActionTypes.LOAD_REVIEW_DATA_DONE:
    storeHelper.set('loadState', 'done');
    return payload;
  case ActionTypes.LOAD_REVIEW_DATA_FAIL:
    storeHelper.set('loadState', 'failed');
    return [];
  case ActionTypes.ADD_REVIEW_REQUEST:
    storeHelper.set('saveState', 'wait');
    return state || [];
  case ActionTypes.ADD_REVIEW_DONE:
    storeHelper.set('saveState', 'done');
    state.push(payload);
    return state;
  case ActionTypes.ADD_REVIEW_FAIL:
    storeHelper.set('saveState', 'failed');
    return state || [];
  case ActionTypes.UPDATE_REVIEW_REQUEST:
    storeHelper.set('saveState', 'wait');
    return state || [];
  case ActionTypes.UPDATE_REVIEW_DONE:
    storeHelper.set('saveState', 'done');
    for (var i = 0; i < state.length; i++) {
      if (state[i].id === payload.id) {
        state[i] = payload;
        break;
      }
    }
    return state;
  case ActionTypes.UPDATE_REVIEW_FAIL:
    storeHelper.set('saveState', 'failed');
    return state || [];
  case ActionTypes.REMOVE_REVIEW_REQUEST:
    storeHelper.set('saveState', 'wait');
    return state || [];
  case ActionTypes.REMOVE_REVIEW_DONE:
    storeHelper.set('saveState', 'done');
    for (var i = 0; i < state.length; i++) {
      if (state[i].id === payload) {
        state.splice(i, 1);
        break;
      }
    }
    return state;
  case ActionTypes.REMOVE_REVIEW_FAIL:
    storeHelper.set('saveState', 'failed');
    return state || [];
  }
  return state || [];
}

function comments(state, action) {
  var payload = action.payload;
  switch (action.type) {
  case ActionTypes.LOAD_COMMENT_DATA_FAIL:
    return [];
  case ActionTypes.LOAD_COMMENT_DATA_DONE:
    return payload;
  case ActionTypes.LOAD_COMMENT_DATA_REQUEST:
    return [];
  case ActionTypes.ADD_COMMENT_DONE:
    state.push(payload);
    return state;
  }
  return state || []
}

function error(state, action) {
  var payload = action.payload;
  storeHelper.set('netState', 'init');
  switch (action.type) {
  case ActionTypes.CONNECT_NET_FAIL:
    storeHelper.set('netState', 'failed');
    return payload;
  case ActionTypes.ERROR:
    return payload;
  case ActionTypes.CLEAR_ERROR:
    return '';
  }
  return state;
}

function appReviews(state, action) {
  var payload = action.payload;
  switch (action.type) {
  case ActionTypes.LOAD_PROJECT_REVIEWS_DONE:
    return payload;
  case ActionTypes.LOAD_PROJECT_REVIEWS_REQUEST:
    return [];
  case ActionTypes.LOAD_PROJECT_REVIEWS_FAIL:
    return [];
  }
  return state || [];
}

module.exports = function (state, action) {
  return {
    app: app(state.app, action),
    current: current(state.current, action),
    target: target(state.target, action),
    animation: animation(state.animation, action),
    config: config(state.config, action),
    review: review(state.review, action),
    comments: comments(state.comments, action),
    error: error(state.error, action),
    appReviews: appReviews(state.appReviews, action)
  };
};



// WEBPACK FOOTER //
// ./src/reducers/AppReducer.js